import * as React from 'react';
import { getSessionStorageItem, setSessionStorageItem } from '@grandvisionhq/utils';
import { useRoutingContext } from '../pages/BookAppointment/context/RoutingContext/context.js';

const STORAGE_KEY = 'aab_appointmentState';
const useAppointmentSessionState = ()=>{
    const [, { queryParams , currentRoute  }] = useRoutingContext();
    const getAppointmentSessionState = React.useCallback(()=>{
        try {
            const item = getSessionStorageItem(STORAGE_KEY);
            if (item) {
                return JSON.parse(item);
            }
        } catch (event) {
            return undefined;
        }
    }, []);
    const setAppointmentSessionState = React.useCallback(()=>{
        const sessionValue = {
            currentRoute,
            queryParams
        };
        setSessionStorageItem(STORAGE_KEY, sessionValue);
    }, [
        currentRoute,
        queryParams
    ]);
    const removeAppointmentSessionState = React.useCallback(()=>{
        globalThis.sessionStorage.removeItem(STORAGE_KEY);
    }, []);
    return {
        getAppointmentSessionState,
        setAppointmentSessionState,
        removeAppointmentSessionState
    };
};
var useAppointmentSessionState$1 = useAppointmentSessionState;

export { useAppointmentSessionState$1 as default, useAppointmentSessionState };
//# sourceMappingURL=use-appointment-session-state.js.map
